export default "__VITE_ASSET__BW0chhOz__"